<template>
  <div class="progress-bar" ref="bar" @selectstart="selectstart" @mousedown="touchstart" @mousemove="touchmove" @mouseup.stop="touchend">
    <div class="bar-top">
      <slot>
      </slot>
      <div class="player-time" v-if="duration>0">
        {{currentTimeStr}} / {{durationTimeStr}}
      </div>
    </div>
    <div class="bar">
      <div :style="progressStyle" class="bar-inner">
        <div :style="pointStyle" class="point"></div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapGetters,
  mapActions
} from 'vuex';

import helpers from 'dom-helpers';
import events from 'dom-helpers/events';
import util from 'libs/util'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    currentTime: {
      type: Number,
      default: ''
    },
    duration: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentTimeStr: '',
      durationTimeStr: ''
    }
  },
  computed: {
    progressStyle() {
      let curWidth = this.wrapWidth * this.curPercent;
      return {
        width: `${curWidth || 0}px`
      }
    },
    pointStyle() {
      let maxWidth = this.wrapWidth - 5;
      let curWidth = maxWidth * this.curPercent;

      return {
        left: `${curWidth}px`
      }
    }
  },
  watch: {
    currentTime(newVal, oldVal) {
      if (newVal != oldVal) {
        this.currentTimeStr = util.date.formatTime(newVal);
        if (!this.isDraging) {
          if (this.duration) {
            this.curPercent = newVal / this.duration;
          } else {
            this.curPercent = 0;
          }
        }
      }
    },
    duration(newVal, oldVal) {
      if (newVal != oldVal) {
        this.durationTimeStr = util.date.formatTime(newVal);
      }
    }
  },
  mounted() {
    this.isDraging = false;
    this.startX = 0;
    if (this.$refs.bar) {
      this.wrapWidth = helpers.width(this.$refs.bar);
      this.offsetX = helpers.offset(this.$refs.bar).left;
    }
    this.currentTimeStr = util.date.formatTime(this.currentTime);
    this.durationTimeStr = util.date.formatTime(this.duration);
    if (this.duration) {
      this.curPercent = this.currentTime / this.duration;
    } else {
      this.curPercent = 0;
    }
    events.on(document, 'mouseup', () => {
      this.isDraging = false
    }, false)
  },
  data() {
    return {
      curPercent: 0,
      currentTimeStr: '00:00',
      durationTimeStr: util.date.formatTime(this.duration) || '00:00'
    }
  },
  methods: {
    touchstart(e) {
      if (
        this.disabled ||
        (event.button !== undefined && event.button !== 0) ||
        !this.isInTarget(event.target)
      ) {
        return
      }
      e.preventDefault();
      this.isDraging = true;
    },
    isInTarget(el) {
      if (!el) return false

      if (el === this.$el) {
        return true
      } else {
        return this.isInTarget(el.parentElement)
      }
    },
    selectstart() {
      return false
    },
    touchmove(e) {
      if (!this.isDraging) return;
      e.preventDefault();
      if (this.duration > 0) {
        const clientX = e.pageX - this.offsetX;
        let per = clientX / this.wrapWidth;
        if (per > 1) {
          per = 1;
        }
        if (per < 0) {
          per = 0;
        }
        if (this.duration > 0) {
          this.curPercent = per;
        }
      }
    },
    touchend(e) {
      if (!this.isDraging) return
      e.preventDefault()
      const clientX = e.pageX - this.offsetX;
      let per = clientX / this.wrapWidth;
      if (per < 0) {
        per = 0;
      }
      if (per > 1) {
        per = 1;
      }
      if (this.duration > 0) {
        this.curPercent = per;
        let s = this.duration * this.curPercent;
        this.$emit('touchend', s, per);
        setTimeout(() => {
          this.isDraging = false;
        }, 200)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.progress-bar {
  box-sizing: border-box;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;
  .bar-top {
    display: flex;
    align-items: center;
    // padding: 2px 0 12px;
    padding-bottom: 10px;
    margin-top: -2px;
  }
  .bar {
    height: 4px;
    // background: #62C565;
    background: rgba(87, 174, 89, .1);
    border-radius: 1px 0px 0px 1px;
    width: 100%;
    .bar-inner {
      background: #57AE59;
      height: 4px;
      position: relative;
      .point {
        width: 14px;
        height: 14px;
        background: #57AE59;
        border-radius: 50%;
        position: absolute;
        left: 0;
        top: -5px;
        cursor: pointer;
      }
    }
  }
  .player-time {
    font-size: 12px;
    color: #333333;
    // color: #fff;
  }
}
</style>